import { MoSearchResponse } from 'ts/shared/interfaces/MOResponse';
import axios from 'axios';

export const getRandomImage = async () => {
  try {
    const response = await axios.get('data/RandomImage');
    return response.data;
  } catch (error) {
    return undefined;
  }
};

export const getWorkingHours = async (lang?: string) => {
  try {
    const wh = sessionStorage.getItem(`workingHours_${lang}`);
    if (wh) {
      return JSON.parse(wh);
    }

    const response = await axios.get('Account/GetWorkingHours', { params: { lang } });
    sessionStorage.setItem(`workingHours_${lang}`, JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    return undefined;
  }
};
export interface GlobalsConfig {
  useCognito: boolean;
  appId: string;
  managerAppId: string;
  useBeproCognito: boolean;
  isManager?: boolean;
  useAzureAD?: boolean;
}
export const getGlobalsConfig = async (): Promise<GlobalsConfig | undefined> => {
  const globals = localStorage.getItem('globals');
  if (globals) {
    return JSON.parse(globals);
  }

  try {
    const url = 'data/Globals';

    const globals = (await axios.get(url)).data;
    localStorage.setItem('globals', JSON.stringify(globals));
    return globals;
  } catch (err) {
    return undefined;
  }
};
export const setGlobalsManager = (isManager: boolean) => {
  const globals = localStorage.getItem('globals');
  if (globals) {
    const globalsObj = JSON.parse(globals);
    globalsObj.isManager = isManager;
    localStorage.setItem('globals', JSON.stringify(globalsObj));
  }
};

interface LoginAsParams {
  userCode: number;
  departmentId: number;
  branchId: number;
  recaptchaToken: string;
}

export const loginAs = async (params: LoginAsParams): Promise<any | undefined> => {
  try {
    const url = 'Account/LoginAs';
    return (await axios.post(url, params)).data;
  } catch (err) {
    return undefined;
  }
};

export const logoutAs = async (recaptchaToken: string): Promise<any | undefined> => {
  try {
    const url = 'Account/ResetLoginAs';
    return (await axios.post(url, { recaptchaToken })).data;
  } catch (err) {
    return undefined;
  }
};

export const getSearchData = async (): Promise<MoSearchResponse | undefined> => {
  try {
    const url = 'MyOrders/GetSearchFilters';
    const { data } = await axios.get<MoSearchResponse>(url);

    return {
      ...data,
      searchRequest: {
        ...data.searchRequest,
        orderSupplier: '',
        orderItem: '',
        orderStatus: 'RQ;OK;HK;HX;VOUCHER',
      },
    };
  } catch (err) {
    return undefined;
  }
};

export const getGtprCredentials = async (): Promise<any | undefined> => {
  const gtprCred = localStorage.getItem('gtprCredentials');

  if (gtprCred) {
    return JSON.parse(gtprCred);
  }

  try {
    const path = 'Account/GetGtprCredentials';
    const res = await axios.get(path);
    localStorage.setItem('gtprCredentials', JSON.stringify(res.data));
    return res.data;
  } catch {
    return undefined;
  }
};

export const forgotPassword = async (email: string): Promise<any | undefined> => {
  try {
    const url = 'Account/ForgotPassword';
    return (await axios.post(url, { email })).data;
  } catch (err) {
    return undefined;
  }
};

export const resetPassword = async (id: string) => {
  const url = `/ResetPassword/` + id;
  const res = await axios.get(url);
  return res.data;
};
